'use client';

import { ReactNode } from 'react';

import { RecapAsset } from '@/api/trading/types';
import { useRecap } from '@/api/trading/useRecap';
import { RankingCardHeader } from '@/blocks/components/RankingCards/RankingCard/Header';
import { RankingCardTable } from '@/blocks/components/RankingCards/RankingCard/Table';

import styles from './styles.module.scss';

interface RankingCardProps {
  assets: RecapAsset[];
  icon: ReactNode;
  title: ReactNode;
  fields: any[];
}

export function RankingCard(props: RankingCardProps) {
  const { markets, loading, error } = useRecap();

  if (!markets) {
    return null;
  }

  const assets = props.assets.map((propsAsset) => {
    return markets.find((marketsAsset) => marketsAsset.name === propsAsset.name) || propsAsset;
  });

  return (
    <div className={styles.card}>
      <RankingCardHeader title={props.title} icon={props.icon} />
      <RankingCardTable assets={assets} fields={props.fields} />
    </div>
  );
}
